<template>
  <v-container fluid>
    <v-row class="custom-form-control">
      <v-col cols="12" class="pt-0 pb-0">
        <v-btn class="ma-2" outlined color="indigo" @click.native="SaveNewInFile">SaveNew</v-btn>
        <v-btn class="ma-2" outlined color="indigo" @click.native="SaveInFile">Save</v-btn>
      </v-col>
    </v-row>
    <v-row class="custom-form-control">
      <v-col cols="12" class="pt-0 pb-0">
        <v-text-field
          v-model="this.IN_FILE_ID"
          height="50"
          solo
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="custom-form-control">
      <v-col cols="12" class="pt-0 pb-0">
        <InputEditor :value="infiledata" @changeData="changeInFileData"></InputEditor>
      </v-col>
    </v-row>
    <v-row class="custom-form-control">
      <v-col cols="12" class="pt-0 pb-0">
        <v-btn class="ma-2" outlined color="indigo" @click.native="SaveNewWorkSpaceFile">SaveNew</v-btn>
        <v-btn class="ma-2" outlined color="indigo" @click.native="SaveWorkSpaceFile">Save</v-btn>
        <v-btn class="ma-2" outlined color="indigo" @click.native="ReadWorkSpaceFile">Open</v-btn>
        <v-btn class="ma-2" outlined color="indigo" @click.native="Build">Build</v-btn>
      </v-col>
    </v-row>
    <v-row class="custom-form-control">
      <v-col cols="12" class="pt-0 pb-0">
        <v-select
          v-model="selectMapType"              
          :items="mapType"
          placeholder="Select map type"
          solo
        ></v-select>       
       </v-col>
       <v-col cols="12" md="4">         
        <v-btn class="ma-2" outlined color="indigo" @click.native="Execute">Execute</v-btn>
       </v-col>
    </v-row>
    <v-row class="custom-form-control">
      <v-col cols="12" class="pt-0 pb-0">       
        <v-select
          v-model="selectScanner"
          :items="scannerType"
          placeholder="Select scanner type"
          solo
        ></v-select>       
       </v-col>
       <v-col cols="12" md="4">         
        <v-btn class="ma-2" outlined color="indigo" @click.native="exeAlgetaScanner">Exe Algeta Scanner</v-btn>
       </v-col>      
    </v-row>
    <v-row class="custom-form-control">
      <v-col cols="12" class="pt-0 pb-0">
        <v-text-field
          v-model="this.FILE_ID"
          height="50"
          solo
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="custom-form-control">
      <v-col cols="12" class="pt-0 pb-0">
        <MapEditor :value="filedata" @changeData="changeData"></MapEditor>
      </v-col>
    </v-row>
    <v-row class="custom-form-control">
      <v-col cols="12" class="pt-0 pb-0">
        <v-text-field
          v-model="buildRst"
          height="50"
          solo
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="custom-form-control">
      <v-col cols="12" class="pt-0 pb-0">
        <v-textarea
          v-model="buildMsg"
          solo
          height="300"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row class="custom-form-control">
      <v-col cols="12" class="pt-0 pb-0">
        <v-textarea
          v-model="outputMsg"
          solo
          height="300"
        ></v-textarea>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import InputEditor from '@/vue-dlb/components/viewers/MapEditor.vue';
import MapEditor from '@/vue-dlb/components/viewers/MapEditor.vue';
import ObjDataSet from "@/vue-dlb/models/objdataset";
import ObjTrSet from "@/vue-dlb/models/objtrset";

import { mapState } from "vuex";

export default {
  components: {
    InputEditor,
    MapEditor
  },
  computed: {
    ...mapState('mapbuilder',
    {
      savedFile: "savedFile",
      buildResult: "buildResult",
      exeResult: "exeResult"
    }),
    ...mapState('common',
    {
      fileContent: "fileContent"
    }),
  },
  data() {
    return {
      /* eslint-disable */
      infiledata: '',
      filedata: '',
      buildMsg: '',
      buildRst: '',
      outputMsg: '',
      mapfile: '',
      IN_FILE_ID: '',
      FILE_ID: '',
      selectMapType: 'MAPP',
      mapType: [
        {value: 'SCAN', text: 'scanner'},
        {value: 'MAPP', text: 'mapper'}
      ],
      selectScanner: 'ediscanner',
      scannerType: [
        {value: 'ediscanner', text: 'ediscanner'},
        {value: 'jsonscanner', text: 'jsonscanner'},
        {value: 'xmlscanner', text: 'xmlscanner'}
      ],
      saveItemsParams:{
        header: ['SYSSTATUS','USER_ID','FOLD_ID','FILE_ID','USR_FILE_NAME','USR_FILE_SIZE','USR_FILE_TYPE'],
        data:[],
      },
      buildItemsParams:{
        header: ['FILE_ID','MAP_TYPE','LIB_VER'],
        data:[],
      },
      exeItemsParams:{
        header: ['IN_FILE_ID','EX_FILE_ID','MAP_TYPE','LIB_VER'],
        data:[],
      },      
      exeScannerItemsParams:{
        header: ['IN_FILE_ID','SCAN_TYPE','STDDB_VER'],
        data:[],
      },            
      uploadHeader: {
        header: [
          {id: 'FILE_NAME', type: 'STRING', size: 100},
          {id: 'FILE_DATA', type: 'BLOB'}
        ],
        data: {
          FILE_NAME: '',
          FILE_DATA: ''
        },
      },
    }
  },
  methods: {
    SaveNewInFile() {
      console.log('-------SaveNewInFile--------');
      let savefile = {};
      savefile.SYSSTATUS = 'I';
      savefile.USER_ID = $cookies.get('user-id');
      savefile.FOLD_ID ='BD00000003';
      savefile.FILE_ID = '';
      savefile.USR_FILE_NAME = 'AprilMapBuildTest.in';
      savefile.USR_FILE_SIZE = '';
      savefile.USR_FILE_TYPE = 'txt';
      savefile.file = this.infiledata;
      console.log("-savefile.file:" + this.infiledata);
      this.saveItemsParams.data[0] = savefile;
      Store.dispatch("mapbuilder/saveWorkSpaceMapFile", this.saveItemsParams).then(() => {
        console.log("--------- Finished to process ----------");
        this.IN_FILE_ID = this.savedFile[0].FILE_NAME;
      });
    },
    SaveInFile() {
      console.log('-------SaveInFile--------');
      let savefile = {};
      savefile.SYSSTATUS = 'U';
      savefile.USER_ID = $cookies.get('user-id');
      savefile.FOLD_ID ='BD00000003';
      savefile.FILE_ID = this.IN_FILE_ID;
      savefile.USR_FILE_NAME = 'AprilMapBuildTest.in';
      savefile.USR_FILE_SIZE = '';
      savefile.USR_FILE_TYPE = 'txt';
      savefile.file = this.infiledata;
      console.log("-savefile.file:" + this.infiledata);
      this.saveItemsParams.data[0] = savefile;
      Store.dispatch("mapbuilder/saveWorkSpaceMapFile", this.saveItemsParams).then(() => {
        console.log("--------- Finished to process ----------");
        //console.log(JSON.stringify(this.masterItems));
      });
    },
    SaveNewWorkSpaceFile() {
      console.log('-------SaveNewWorkSpaceFile--------');
      let savefile = {};
      savefile.SYSSTATUS = 'I';
      savefile.USER_ID = $cookies.get('user-id');
      savefile.FOLD_ID ='BD00000003';
      savefile.FILE_ID = '';
      savefile.USR_FILE_NAME = 'AprilMapBuildTest.cpp';
      savefile.USR_FILE_SIZE = '';
      savefile.USR_FILE_TYPE = 'cpp';
      savefile.file = this.filedata;
      console.log("-savefile.file:" + this.filedata);
      this.saveItemsParams.data[0] = savefile;
      Store.dispatch("mapbuilder/saveWorkSpaceMapFile", this.saveItemsParams).then(() => {
        console.log("--------- Finished to process ----------");
        this.FILE_ID = this.savedFile[0].FILE_NAME;
      });
    },
    SaveWorkSpaceFile() {
      console.log('-------SaveWorkSpaceFile--------');
      let savefile = {};
      savefile.SYSSTATUS = 'U';
      savefile.USER_ID = $cookies.get('user-id');
      savefile.FOLD_ID ='BD00000003';
      savefile.FILE_ID = this.FILE_ID;
      savefile.USR_FILE_NAME = 'AprilMapBuildTest.cpp';
      savefile.USR_FILE_SIZE = '';
      savefile.USR_FILE_TYPE = 'cpp';
      savefile.file = this.filedata;
      console.log("-savefile.file:" + this.filedata);
      this.saveItemsParams.data[0] = savefile;
      Store.dispatch("mapbuilder/saveWorkSpaceMapFile", this.saveItemsParams).then(() => {
        console.log("--------- Finished to process ----------");
        //console.log(JSON.stringify(this.masterItems));
      });
    },
    ReadWorkSpaceFile () {
      console.log("--------- ReadWorkSpaceFile ----------");
      Store.dispatch('common/viewFileData', this.FILE_ID);
    },
    Build() {
      console.log('-------Build--------');
      this.buildItemsParams.data[0] = {
        FILE_ID: this.FILE_ID,
        MAP_TYPE: this.selectMapType,
        LIB_VER: 'v2'
      };
      Store.dispatch("mapbuilder/mapBuild", this.buildItemsParams).then(() => {
        console.log("--------- Finished to process ----------");
        // console.log(JSON.stringify(this.buildResult));
        this.buildRst = '[' + this.buildResult[0].RESULT + ']';
        this.buildMsg = this.buildResult[0].MSG;
      });
    },
    Execute() {
      console.log('-------Execute--------');
      this.exeItemsParams.data[0] = {
        IN_FILE_ID: this.IN_FILE_ID,
        EX_FILE_ID: this.FILE_ID,
        MAP_TYPE: this.selectMapType,
        LIB_VER: 'v2'
      };
      Store.dispatch("mapbuilder/mapExecute", this.exeItemsParams).then(() => {
        console.log("--------- Finished to process ----------");
        // console.log(JSON.stringify(this.exeResult));
        this.buildMsg = this.exeResult[0].RESULT;
        this.outputMsg = this.exeResult[0].MSG;
      });    
    },     
    exeAlgetaScanner() {
      console.log('-------exeAlgetaScanner--------');                
      this.exeScannerItemsParams.data[0] = {
        IN_FILE_ID: this.IN_FILE_ID,        
        SCAN_TYPE: this.selectScanner,
        STDDB_VER: 'db'
      };      
      Store.dispatch("mapbuilder/exeAlgetaScanner", this.exeScannerItemsParams).then(() => { 
        console.log("--------- Finished to process ----------"); 
        // console.log(JSON.stringify(this.exeResult));
        this.buildMsg = this.exeResult[0].RESULT;        
        this.outputMsg = this.exeResult[0].MSG;
      });    
    },         
    changeData (data) {      
      this.filedata = data;
    },
    changeInFileData (data) {
      this.infiledata = data;
    }
  },
  created () {

    },
    mounted () {
    }
};
</script>
